<div class="mt-2 pb-7">
    <ng-container [formGroup]="form" *ngIf="isReady">
        <ui-form-array
            [manuelDisableSaveButton]="form.disabled"
            [useAddButton]="true"
            [useRemoveButton]="true"
            formArrayName="entityModel"
            (onAddClicked)="addItem()"
            headerText="{{ 'hrPerPersonnel.detailSearch.rule' | translate }}"
        >
            <ng-template let-index hvlngTemplate="formItem">
                <div class="p-fluid formgrid grid" [formGroupName]="index">
                    <ng-container [formGroup]="form.controls.entityModel['controls'][index]">
                        <hvl-form-item key="table" class="col-3"
                                       label="{{ 'hrPerPersonnel.detailSearch.table' | translate }}">
                            <p-dropdown
                                #tableDd
                                class="mr-2"
                                appendTo="body"
                                [options]="tableList"
                                formControlName="entity"
                                [optionLabel]="'name'"
                                [optionValue]="'value'"
                                [showClear]="true"
                                [id]="'table_'+index"
                                [placeholder]="'placeHolder' | translate"
                                (onChange)="getEntityInfo($event.value,index)"
                                autofocus="true"
                            >
                            </p-dropdown>
                        </hvl-form-item>
                        <ng-container
                            [formGroup]="form.controls.entityModel['controls'][index].controls['rules'].controls[0]">
                            <hvl-form-item key="table" class="col-3"
                                           label="{{ 'hrPerPersonnel.detailSearch.ruleField'| translate }}">
                                <p-dropdown
                                    class="mr-2"
                                    appendTo="body"
                                    [options]="attributeList[index]"
                                    formControlName="field"
                                    [optionLabel]="'text'"
                                    [optionValue]="'value'"
                                    [showClear]="true"
                                    [placeholder]="'placeHolder' | translate"
                                    (onChange)="fieldOnChange($event.value,index)"

                                >
                                </p-dropdown>
                            </hvl-form-item>

                            <hvl-form-item key="table" class="col-3"
                                           label="{{ 'hrPerPersonnel.detailSearch.operator' | translate }}">
                                <p-dropdown
                                    class="mr-2"
                                    appendTo="body"
                                    [options]="operatorList"
                                    formControlName="operator"
                                    [optionLabel]="'name'"
                                    [optionValue]="'value'"
                                    [showClear]="true"
                                    [placeholder]="'placeHolder' | translate"
                                >
                                </p-dropdown>
                            </hvl-form-item>
                            <ng-container [ngSwitch]="selectedFieldData[index]?.comType">
                                <hvl-form-item key="value" class="col-3"
                                               label="{{ 'hrPerPersonnel.detailSearch.value' | translate }}">
                                    <ng-container *ngSwitchCase="'String'">
                                        <input pInputText id="value1_input" type="text" formControlName="value" />
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'boolean'">

                                        <p-checkbox
                                            binary="true"
                                            formControlName="value"
                                            id="value1_boolean"
                                            name="value1_boolean"
                                        ></p-checkbox>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'number'">
                                        <p-inputNumber
                                            id="value1_numericInput"
                                            mode="decimal"
                                            [minFractionDigits]="2"
                                            [maxFractionDigits]="2"
                                            inputStyleClass="text-right"
                                            formControlName="value"
                                        ></p-inputNumber>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'category'">
                                        <p-dropdown
                                            *ngIf="!isMultiSelect(index)"
                                            class="mr-2"
                                            appendTo="body"
                                            [options]="selectedFieldData[index].options.source | async"
                                            formControlName="value"
                                            [optionLabel]="selectedFieldData[index].options.label"
                                            [optionValue]="selectedFieldData[index].options.value"
                                            [showClear]="true"
                                            [placeholder]="'placeHolder' | translate"

                                        >
                                        </p-dropdown>
                                        <p-multiSelect
                                            *ngIf="isMultiSelect(index)"
                                            class="mr-2"
                                            appendTo="body"
                                            [options]="selectedFieldData[index].options.source | async"
                                            formControlName="value"
                                            [optionLabel]="selectedFieldData[index].options.label"
                                            [optionValue]="selectedFieldData[index].options.value"
                                            [showClear]="true"
                                            [placeholder]="'placeHolder' | translate"
                                        >
                                        </p-multiSelect>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'Date'">
                                        <p-calendar dateFormat="dd.mm.yy" formControlName="value"
                                                  showButtonBar="true"
                                                    showIcon="true"></p-calendar>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'picker'">
                                        <hr-per-personnel-search
                                            *ngIf="selectedFieldData[index]?.pickerType ==='people'"
                                            #hrPerPersonnelSearch
                                            [selectionMode]="isMultiSelect(index) ? 'multiple' : 'single'"
                                            [isPictureVisible]="false"
                                            [minSearchLength]="3"
                                            placeHolder="{{ 'placeHolder' | translate }}"
                                            [showEmptyMessage]="true"
                                            [emptyMessage]="'noRecordsFound' | translate"
                                            (valueEvent)="setPeopleSelection($event, index)"
                                        ></hr-per-personnel-search>
                                        <organization-picker
                                            *ngIf="selectedFieldData[index]?.pickerType ==='organization'"
                                            [selectionMode]="isMultiSelect(index) ? 'multiple' : 'single'"
                                            (valueEvent)="setOrganizationUnitFromSelection($event,index)"></organization-picker>


                                        <position-picker *ngIf="selectedFieldData[index]?.pickerType ==='position'"
                                                         [selectionMode]="isMultiSelect(index) ? 'multiple' : 'single'"
                                                         (valueEvent)="setPositionSelection($event,index)"
                                                         [positionPicker]="pickerData[index] || []"></position-picker>

                                    </ng-container>
                                </hvl-form-item>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </div>
            </ng-template>
        </ui-form-array>
    </ng-container>
    <ui-sticky-buttonbar>
        <div class="mr-2">
            <button (click)="onCancel()" [label]="'button.cancel' | translate"
                    class="p-button-text" pButton></button>
        </div>
        <div>
            <button (click)="onSave()" [label]="'button.save' | translate"
                    pButton></button>
        </div>
    </ui-sticky-buttonbar>
</div>

